import { render, staticRenderFns } from "./LeadPage.vue?vue&type=template&id=6c848c69&scoped=true"
import script from "./LeadPage.vue?vue&type=script&lang=js"
export * from "./LeadPage.vue?vue&type=script&lang=js"
import style0 from "./LeadPage.vue?vue&type=style&index=0&id=6c848c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c848c69",
  null
  
)

/* custom blocks */
import block0 from "./LeadPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports